import { handleActions } from 'redux-actions';

const initialState = {
  bookingIdToDelete: 0,
  dialogMessages: {},
  dialogType: '',
  isDialogOpen: false,
  file: '',
  booking: {},
};

const OPEN_DIALOG = 'OPEN_DIALOG';
const OPEN_PARKING_DIALOG = 'OPEN_PARKING_DIALOG';
const CLOSE_DIALOG = 'CLOSE_DIALOG';
const OPEN_DIALOG_WITH_FILE = 'OPEN_DIALOG_WITH_FILE';

/** ******************* ACTIONS ******************** */

export const openDialog = (dialogType = '', dialogMessages, bookingIdToDelete = 0) => ({
  type: [OPEN_DIALOG],
  bookingIdToDelete,
  dialogMessages,
  dialogType,
});

export const openParkingDialog = (dialogType, booking) => ({
  type: [OPEN_PARKING_DIALOG],
  dialogType,
  booking,
});

export const closeDialog = () => ({
  type: [CLOSE_DIALOG],
});

export const openDialogWithFile = (dialogType = '', file, caller = '') => ({
  type: [OPEN_DIALOG_WITH_FILE],
  dialogType,
  file,
  caller,
});

/** ******************* REDUCER ******************** */

export default handleActions(
  {
    [OPEN_DIALOG]: (state, { dialogType, dialogMessages, bookingIdToDelete }) => ({
      ...state,
      isDialogOpen: true,
      bookingIdToDelete,
      dialogMessages,
      dialogType,
    }),

    [CLOSE_DIALOG]: state => ({
      ...state,
      isDialogOpen: false,
    }),
    [OPEN_DIALOG_WITH_FILE]: (state, { dialogType, file, caller }) => ({
      ...state,
      isDialogOpen: true,
      dialogType,
      file,
      caller,
    }),
    [OPEN_PARKING_DIALOG]: (state, { dialogType, booking }) => ({
      ...state,
      isDialogOpen: true,
      dialogType,
      booking,
    }),
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/redux/alert.js